import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { BaseMediaApiModel } from '@rocksoft/inroom-sdk';

@Component({
  selector: 'era-tv-channel',
  templateUrl: './tv-channel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./tv-channel.component.scss'],
})
export class TvChannelComponent {
  readonly tvChannel = input.required<BaseMediaApiModel>();
}
